export const getLocaleInfo = state => state.common.localeInfo;
